import {Component, OnInit} from '@angular/core';
import {PagesHttpService} from '../../../services/http-services/pages/pages-http.service';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
})
export class TermsOfUseComponent implements OnInit {
  useOfTermsPageContent = ''
  constructor(private pagesHttpService: PagesHttpService) { }

  ngOnInit(): void {
    this.getTermsOfUsePageContent();
  }

  getTermsOfUsePageContent(): void {
    this.pagesHttpService.getSinglePage({pageId: 1}).then(res => {
      this.useOfTermsPageContent = res.data.content.replace(/&nbsp;/g, ' ');
    });
  }
}
